import feature1 from "../../assets/feature1.png"
import feature2 from "../../assets/feature2.png"
import feature3 from "../../assets/feature3.png"

export const Data = [
    {
        id: 1,
        image: feature1,
        title: "Mango",
        location: "Ghana"
    },{
        id: 2,
        image: feature2,
        title: "Pineapple",
        location: "Ghana"
    },{
        id: 3,
        image: feature3,
        title: "Pear",
        location: "Ghana"
    }
]